// Environment-aware theming. The primary gradient defaults to the production
// blue (defined in App.css :root), so production needs no JS and never flashes.
// Outside production we swap it for green at runtime, giving staging / localhost
// an unmistakable "this is NOT prod" look.

// Production is the canonical site only; staging, localhost and any preview host
// all count as non-production.
const PRODUCTION_HOSTS = ['top-spin.ro', 'www.top-spin.ro'];
const IS_PRODUCTION = PRODUCTION_HOSTS.includes(window.location.hostname);

// Dark-green → bright-green, mirroring the depth of the prod navy→blue gradient
// and reusing the app's green token (--c-green-light #1ECD4D).
const NON_PROD_GRADIENT = 'linear-gradient(90deg, #013318, #127a2e)';

if (!IS_PRODUCTION) {
  document.documentElement.style.setProperty('--primary-gradient', NON_PROD_GRADIENT);
}

export { IS_PRODUCTION };
